import styled, { css } from 'styled-components';

export const IconRowWrapper = styled.div`
  margin-left: ${props => (props.marginLeft ? `${props.marginLeft}em` : '0')};
  margin-right: ${props => (props.marginRight ? `${props.marginRight}em` : '0')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 21px;
  height: 22px;
  border-radius: 5px;
  overflow: hidden;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 16px;
    height: 17px;
  }
`;

export const Icon = styled.i`
  color: ${props => props.theme.colors[props.bg]};
  display: block;
  position: absolute;
  top: 0px;
  left: -1px;
  font-size: 23px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 18px;
  }
  &:before { 
    color: ${props => props.theme.colors[props.bg]};
  }
`;

export const NumberSpan = styled.span`
  position: absolute;
  top: 5px;
  width: 22px;
  left: 0px;
  color: ${props => props.theme.colors[props.color]};
  font-size: ${props => props.size}px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    top: 3px;
    font-size: 11px;
    width: 16px;
  }
  ${props => (props.font) && css` 
    font-family: ${props.theme.fontSets[props.font]};
  `};
`;



// WEBPACK FOOTER //
// ./src/components/MatchRowIcon/styles.js